import { render, staticRenderFns } from "./TourInduction.vue?vue&type=template&id=614c36e9&"
import script from "./TourInduction.vue?vue&type=script&lang=js&"
export * from "./TourInduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports